export const VOICE_BARS = [42, 70, 36, 88, 54, 64, 32, 76, 46, 84, 38, 66, 50, 92, 44, 60, 34, 78, 52, 72, 40, 86, 48, 68];

export const VOICE_ACTIVE_COLOR = '#1DA1F2';

export const getTranslatedLabel = (t, key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
};

export const formatVoiceTime = (seconds = 0) => {
    const safeSeconds = Number.isFinite(seconds) ? Math.max(0, seconds) : 0;
    const mins = Math.floor(safeSeconds / 60);
    const secs = Math.floor(safeSeconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
};
